var _path, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEducationAndTraining(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 21C0 9.40204 9.40202 0 21 0C32.598 0 42 9.40204 42 21C42 32.598 32.598 42 21 42C9.40202 42 0 32.598 0 21Z",
    fill: "#FBF0FB"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_0_45)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M27.8025 17.7074L21.4275 15.0824C21.15 14.9699 20.8425 14.9699 20.5725 15.0824L14.1975 17.7074C13.7775 17.8799 13.5 18.2924 13.5 18.7499V23.9999C13.5 24.4124 13.8375 24.7499 14.25 24.7499C14.6625 24.7499 15 24.4124 15 23.9999V20.1224L20.5725 22.4174C20.7075 22.4774 20.8575 22.4999 21 22.4999C21.1425 22.4999 21.2925 22.4699 21.4275 22.4174L27.8025 19.7924C28.2225 19.6199 28.5 19.2074 28.5 18.7499C28.5 18.2924 28.2225 17.8799 27.8025 17.7074ZM21 23.9999C20.655 23.9999 20.3175 23.9324 20.0025 23.8049L16.5 22.3649V25.1324C16.5 25.5749 16.77 25.9799 17.175 26.1599L20.55 27.6299C20.6925 27.6899 20.8425 27.7199 21 27.7199C21.1575 27.7199 21.3075 27.6899 21.45 27.6299L24.825 26.1599C25.2375 25.9799 25.5 25.5824 25.5 25.1324V22.3649L21.9975 23.8049C21.675 23.9399 21.345 23.9999 21 23.9999Z",
    fill: "#AC1DB0"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_0_45"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white",
    transform: "translate(12 12)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEducationAndTraining);
export default __webpack_public_path__ + "static/media/education_and_training.02693d4e0567c658f4e7fe99d08ffcd7.svg";
export { ForwardRef as ReactComponent };